// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3is3B","overflowing":"ReadFullNote_overflowing__lJeVb"};